module.exports = __webpack_public_path__ + "img/users.6c6307ce.svg";